import React from 'react';
import { scoreColor } from '../../lib/healthAnalysis';

/**
 * Animated circular gauge for displaying a 0-100 score.
 * SVG-based, no external dependencies.
 */
const HealthGauge = ({ score, size = 220, label = 'Overall Health Score', testId = 'health-gauge' }) => {
  const radius = (size - 24) / 2;
  const circumference = 2 * Math.PI * radius;
  const validScore = score == null ? 0 : Math.max(0, Math.min(100, score));
  const offset = circumference - (validScore / 100) * circumference;
  const meta = scoreColor(score);

  return (
    <div className="flex flex-col items-center" data-testid={testId}>
      <div className="relative" style={{ width: size, height: size }}>
        <svg width={size} height={size} className="-rotate-90">
          <defs>
            <linearGradient id="gauge-grad" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor={
                score == null ? '#475569' :
                score >= 80 ? '#10b981' :
                score >= 65 ? '#f59e0b' :
                score >= 45 ? '#f97316' : '#f43f5e'
              } />
              <stop offset="100%" stopColor={
                score == null ? '#334155' :
                score >= 80 ? '#06b6d4' :
                score >= 65 ? '#eab308' :
                score >= 45 ? '#f59e0b' : '#dc2626'
              } />
            </linearGradient>
          </defs>
          <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke="rgba(255,255,255,0.05)" strokeWidth="12" />
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            fill="none"
            stroke="url(#gauge-grad)"
            strokeWidth="12"
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            style={{ transition: 'stroke-dashoffset 1.2s cubic-bezier(.4,0,.2,1)' }}
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span className={`text-5xl sm:text-6xl font-black ${meta.text} tabular-nums`}>
            {score == null ? '-' : score}
          </span>
          {score != null && <span className="text-slate-500 text-xs font-medium mt-1">/ 100</span>}
        </div>
      </div>
      <p className="text-slate-300 text-sm sm:text-base mt-4 font-medium">{label}</p>
      <p className={`text-xs sm:text-sm font-semibold mt-1 ${meta.text}`}>{meta.label}</p>
    </div>
  );
};

export default HealthGauge;
